// @need-translate
import {RefObject} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {LogTabType} from '../../../common/LogTabType.enum';
import {useAdjustXAxisScrollPosition} from '../../../common/shared/hooks/useAdjustXAsixScrollPosition';
import {twMerge} from '../../../common/twMerge';
import {PageViewCustomPropsDataKey} from '../../../logging/PageViewCustomPropsDataKey.enum';
import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {SubTabItem} from '../SubTabItem/SubTabItem';
import {SubTabProps} from './SubTabProps.interface';

export function SubTab({
  className,
  tabItems,
  currentTabItemParam,
  onClickTab,
  hasSearchMenu,
  activeColorScheme,
  logTabType,
  onClickSearch,
  ...props
}: SubTabProps) {
  const {tabRef, onSelectTabItem} = useAdjustXAxisScrollPosition(
    tabItems.findIndex(item => item.param === currentTabItemParam)
  );

  if (!tabItems || tabItems.length === 0) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'relative flex h-50pxr w-full flex-row items-center overflow-hidden border-b-1 border-theme-transparent-20 bg-theme-bg-base',
        className
      )}
      {...props}
    >
      {hasSearchMenu && (
        <>
          <div
            onClick={onClickSearch}
            className="flex h-28pxr w-51pxr shrink-0 cursor-pointer items-center"
          >
            <Icon
              type={IconType.SearchListButton}
              className="mr-12pxr ml-15pxr"
            />
          </div>
          <Divider
            direction="vertical"
            color={theme.colors['theme-transparent-20']}
            sizePx={1}
            className="h-28pxr"
          />
        </>
      )}
      <div
        ref={tabRef as RefObject<HTMLDivElement>}
        className={twMerge(
          'flex w-full overflow-x-scroll whitespace-nowrap scrollbar-hide',
          /**
           * 내부에 padding-left, right를 주게 되면 특정 브라우저에서 left는 들어가는데 right는 적용 안되는 현상이 있습니다.
           * 특정 브라우저에서 패딩이 아닌 컨텐츠 영역까지만 스크롤을 보여주기 때문입니다. 참고 https://alexandergottlieb.com/2018/02/22/overflow-scroll-and-the-right-padding-problem-a-css-only-solution/
           * 리스트 내부 첫번째 요소에 before 마지막 요소에 after css 가상요소로 변경했습니다.
           */
          'before:h-1pxr before:w-12pxr before:shrink-0 after:h-1pxr after:w-12pxr after:shrink-0'
        )}
      >
        {tabItems.map((tabItem, idx) => {
          const isSelected = currentTabItemParam === tabItem.param;
          return (
            <UrlLink key={tabItem.param} url={tabItem.href}>
              <SubTabItem
                isActive={isSelected}
                activeColorScheme={activeColorScheme}
                onClick={e => {
                  onClickTab(tabItem.param, e);
                  onSelectTabItem(e.target as HTMLElement);
                }}
                className="not-last-of-type:mr-2pxr"
                {...{
                  [PageViewCustomPropsDataKey.PageCategoryFilter]:
                    isSelected && logTabType === LogTabType.Category
                      ? `page_category_filter=${tabItem.name}`
                      : undefined,
                  [PageViewCustomPropsDataKey.PageGenreFilter]:
                    isSelected && logTabType === LogTabType.Genre
                      ? `page_genre_filter=${tabItem.name}`
                      : undefined,
                }}
              >
                {isSelected && <Text className="blind">선택됨, </Text>}
                {tabItem.name}
                <Text className="blind">
                  탭, {`총 ${tabItems.length}개 중 ${idx + 1}번째`}
                </Text>
              </SubTabItem>
            </UrlLink>
          );
        })}
      </div>
    </div>
  );
}
